const TermsOfUse = () => {
  return (
    <div className="content_sec full">
      <div className="terms_inner">
        <img
          src="assets/images/shoshke_logo.svg"
          loading="lazy"
          alt=""
          className="inner_logo"
        />
        <h1 className="terms_top_title">
          תנאי שימוש באתר ואפליקציית שושק&#x27;ה
        </h1>
        <div className="terms_date_txt"> ( עודכן לאחרונה ב 22.6.2026 )</div>
        <ul role="list" className="terms_list w-list-unstyled">
          <li className="terms_item">
            <h4 className="terms_title">א. מבוא</h4>
            <p className="terms_par">
              1. האתר מופעל על ידי חברת מוטק&#x27;ה ושושק&#x27;ה ניהול אתרים
              בע"מ, ח.פ. 516991213 (להלן: "<strong>החברה</strong>" או "
              <strong>האתר</strong>").
            </p>
            <p className="terms_par">
              2. השימוש באתר, בכל מדיה שהיא (טלפון סלולרי, מחשב, טאבלט או בכל
              דרך אחרת), כפוף לתנאים המפורטים בדף זה להלן (להלן: "
              <strong>תנאי השימוש</strong>")
            </p>
            <p className="terms_par">
              3. חשוב להקפיד ולעיין בתנאי השימוש וזאת כיוון שעצם השימוש באתר
              מעיד על הסכמתך לתנאים המפורטים להלן.
            </p>
            <p className="terms_par">
              4. החברה שומרת על זכותה לעדכן תנאים אלו, על פי שיקול דעתה הבלעדי.
              עליך לעיין מפעם לפעם בתנאי השימוש על מנת לבדוק את הנוסח המעודכן
              שלהם.
              <br />
            </p>
            <p className="terms_par">
              5. התנאים מנוסחים בלשון זכר מטעמי נוחות בלבד, אולם הם מיועדים
              לגברים ולנשים כאחד.
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">
              ב. אין להסתמך באופן בלעדי על המידע, התכנים והשירותים באתר
            </h4>
            <p className="terms_par">
              6. האתר בכללותו, לרבות כל המידע והתכנים באתר, התוכנה העומדת בבסיסו
              וכן מידע אשר הגישה אליו נעשית באמצעות האתר, ובכלל זה מידע אותו
              מקבלת החברה מצדדים שלישיים מוצג באתר כפי שהוא
            </p>
            <p className="terms_par">
              7. באתר תמצא מידע ותכנים מסוגים שונים (כרטיסי חברים, המלצות, עצות,
              חדשות וכל מידע אחר), מטעם החברה וכן מטעם צדדים שלישיים, עליהם אין
              לחברה פיקוח או שליטה
            </p>
            <p className="terms_par">
              8. המידע הנכלל באתר נועד להרחיב את הדעת ולשמש כמידע כללי בלבד.
              בהתאם לכך
            </p>
            <p className="terms_par sub">
              8.1. אתה מצהיר כי ידוע לך כי המידע באתר עלול לכלול אופי של המלצות,
              עצות וחדשות רפואיות, משפטיות, פיננסיות או בעלות כל אופי מקצועי
              אחר, שאין באף אחת מהן להחליף את הצורך בקבלת ייעוץ המותאם לך אישית
            </p>
            <p className="terms_par sub">
              8.2. אתה מסכים לכך שלא תהא לך כל טענה ו/או דרישה ו/או תביעה כלפי
              החברה בקשר להסתמכותך על כל תוכן באתר, ובכלל זה כל המלצה ו/או עצה
              ו/או מידע בעלי אופי רפואי או בעלי כל אופי מקצועי אחר
            </p>
            <p className="terms_par">
              9. השימוש באתר יעשה על אחריותך הבלעדית והמלאה. אין החברה מביעה כל
              עמדה ואין היא אחראית לנזק, הפסד או אובדן אחר הנובעים במישרין או
              בעקיפין, מהדברים הבאים
            </p>
            <p className="terms_par sub">9.1. המידע והתכנים שבאתר;</p>
            <p className="terms_par sub">
              9.2. חומר, מידע, מוצרים, פעילויות ופעולות, אשר הגישה אליהם מתאפשרת
              באמצעות האתר, ובפרט לעניין מוצרים או שירותים המוצעים על ידי צדדים
              שלישיים ולכל עסקה עמם
            </p>
            <p className="terms_par sub">
              9.3. פגם או תקלה בתוכנה, בחומרה או בתשתית המשמשת לפעילות האתר או
              ליצירת הגישה אליו.
            </p>
            <p className="terms_par">
              10. יודגש שהחברה אינה בודקת את מהימנותם, איכותם, שלמותם או דיוקם
              של המידע, הפעילויות והתכנים שמקורם בצדדים שלישיים, כולל משתמשים
              אחרים, והיא לא תישא באחריות לכל אי התאמה, חוסר, הטעיה או טעות
              הכלולים בו ולא תישא באחריות בגין אובדן, הפסד או נזק ישירים או
              עקיפים הנובעים מהסתמכות או שימוש בתכנים או במידע אלו. בין אלה
              נכללים
            </p>
            <p className="terms_par sub">
              10.1. מודעות ופרסומים באתר, ובכלל זה לגבי פעילויות שונות כגון
              טיולים, מפגשים, שיעורי ספורט והרצאות – ר&#x27; הרחבה בנפרד בסעיף
              ט&#x27; להלן
            </p>
            <p className="terms_par sub">
              10.2. אתרים ומקורות שונים ברשת האינטרנט בהם תוכל לקבל שירותי מידע
              שונים ("<strong>האתרים המקושרים</strong>"). החברה לא אחראית על
              פעילות כלשהי באתרים המקושרים, על אי תקינות הקישורים אליהם או על
              השימוש שייעשה במידע שתמסור לאתרים המקושרים או על כל פעילות אחרת
              בהם
            </p>
            <p className="terms_par sub">
              10.3. תוכנות ומשחקים אותם ניתן לטעון אל המחשב האישי שלך ו/או
              קישורים אל אתרים המאפשרים לך לטעון תוכנות ומשחקים כאלה. החברה אינה
              אחראית על פעילותם של תוכנות ומשחקים אלו והשימוש בהם הוא על אחריותך
              בלבד
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">ג. מפגשים וטיולים המוצעים באתר</h4>
            <p className="terms_par">
              11. האתר כולל פרסומים של אירועים מסוגים שונים, כגון מפגשים בבתים
              או במקומות ציבוריים, הרצאות, טיולים ושירותי תיירות בישראל ובחו"ל,
              כולל טיסות, סדנאות, קורסים ועוד
            </p>
            <p className="terms_par">
              12. בחלק מהמקרים, פרסומים אלו נעשים על ידי החברות, גולשים, מנהלי
              קהילות או מובילי קבוצות חברתיות המספקים את השירותים האמורים.
              שירותים אלו הם יזמה פרטית שלהם, ועל אחריותם הבלעדית
            </p>
            <p className="terms_par">
              13. לחברה אין כל קשר לאירועים מסוג זה והשתתפותך בהם היא על אחריותך
              האישית בלבד
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">
              ד. מהן החובות החלות עליך, המשתמש באתר?
            </h4>
            <p className="terms_par">בעצם צפייתך ופעילותך באתר אתה:</p>
            <p className="terms_par">
              14. מסכים ומאשר את מדיניות הפרטיות של החברה, הזמינה בקישור לעיל.
              בפרט אתה מאשר את איסוף המידע לגביך ואת השימוש שיעשה בכל מידע הנאסף
              לגביך באתר
            </p>
            <p className="terms_par">
              15. מודע לכך שלחברה אין כל חובה לשמור מידע מכל סוג, בין אם הוא
              חשוף לציבור ובין אם לאו,  המועלה על ידך לאתר או ליצור גיבויים
              למידע זה, ובפרט במקרה של הפסקת פעילות האתר
            </p>
            <p className="terms_par">
              16. מודע למגבלותיה של רשת האינטרנט בנושא של אבטחת המידע העובר בה
              ומשחרר את החברה מכל אחריות בעניין זה, למעט לעניין מקרים של זדון או
              רשלנות
            </p>
            <p className="terms_par">
              17. מתחייב להשתמש באתר ו/או בשירותים המוצעים בו אך ורק בהתאם לכל
              דין ו/או בהתאם לתנאי שימוש אלו ומדיניות הפרטיות
            </p>
            <p className="terms_par">
              18. מתחייב לא להשתמש באתר באופן הפוגע ו/או משבש פעולתן של מערכות
              מחשב ו/או מחשבים. בכלל זה, אתה מתחייב שלא להפעיל כל יישום מחשב או
              אמצעי אחר על האתר, כולל תוכנות מסוג וירוסים או כל נוזקה
            </p>
            <p className="terms_par">
              19. מתחייב שלא ליצור יותר מחשבון משתמש (פרופיל) אחד וכן שלא ליצור
              חשבונות משתמש פיקטיביים
            </p>
            <p className="terms_par">
              20. מתחייב שלא ליצור חשבון משתמש עבור תאגידים או כל גורם אחר שאינו
              אדם
            </p>
            <p className="terms_par">
              21. מתחייב לעשות שימוש אישי בלבד בחשבון המשתמש, ולא להעבירו לאחר,
              בתמורה או שלא בתמורה
            </p>
            <p className="terms_par">
              22. מסכים שבמקרה של העדר שימוש בחשבון משתמש למשך תקופה רצופה של 6
              חודשים ומעלה, החברה תהיה רשאית להקפיא או למחוק את חשבון המשתמש
            </p>
            <p className="terms_par">
              23. מסכים כי החברה תהיה רשאית, על פי שיקול דעתה הבלעדי
            </p>
            <p className="terms_par sub">
              23.1. למנוע ממך גישה לאתר, להקפיא את חשבון המשתמש שלך, למחוק אותו
              ולעשות כל פעולה שתמנע ממך שימוש באתר ו/או בשירותים המוצעים בו
            </p>
            <p className="terms_par sub">
              23.2. לשתף פעולה עם פעולות אכיפה ובכלל זה להעביר את פרטי ו/או
              דפוסי התנהגותך באתר לצדדים שלישיים אשר יוכיחו שהם נפגעים מפעילותך
              וכן לעשות כל פעולה אחרת אשר החברה תמצא לנכון
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">ה. פרסום תכנים באתר</h4>
            <p className="terms_par">
              24. אתה מסכים שאין כל התחייבות מצד האתר לפרסום תכנים כלשהם שיועלו
              לאתר על ידך, וכי עצם פרסומם ואופן פרסומם, לרבות בדרך של עריכתם,
              הוא בכפוף לשיקול דעתו המוחלט של האתר
            </p>
            <p className="terms_par">
              25. אתה מאשר שידוע לך כי כל תוכן שיועלה על ידך לאתר, עשוי להיות
              חשוף ללא הגבלה
            </p>
            <p className="terms_par">
              26. בעת שיגור או מסירת תכנים לפרסום באתר על ידך, חלה עליך האחריות
              המלאה והבלעדית לכל תוצאה שתנבע מהפרסום
            </p>
            <p className="terms_par">
              27. עליך להקפיד שתכנים המועלים על ידך יהיו חוקיים, כלומר שאין בהם
              לפגוע בזכות של כל אדם או גורם אחרים. בין השאר ולמען הדוגמה בלבד,
              נאסר עליך לפרסם באתר תכנים העולים כדי הפרה של כל דין, אזרחי או
              פלילי ו/או האסורים בפרסום על פי כל דין ו/או על פי כל נוהג מקובל.
              אלו כוללים
            </p>
            <p className="terms_par sub">27.1. כל תוכן העלול להטעות צרכן</p>
            <p className="terms_par sub">
              27.2. כל תוכן בעל אופי פרסומי או מסחרי
            </p>
            <p className="terms_par sub">
              27.3. כל חומר הפוגע או מפר זכויות קנייניות של אחרים – לרבות כל
              זכות קניין רוחני דוגמת זכויות יוצרים או סימני מסחר
            </p>
            <p className="terms_par sub">
              27.4. כל חומר פורנוגראפי או בעל אופי מיני בוטה
            </p>
            <p className="terms_par sub">
              27.5. כל חומר הנוגע לקטינים ומזהה אותם, את פרטיהם האישיים או מענם
              ודרכי ההתקשרות עימם
            </p>
            <p className="terms_par sub">
              27.6. כל תוכנת מחשב, קוד מחשב או יישום העלולים לגרום נזק לחברה או
              לצד שלישי כלשהו, ובכלל זה אלו הכוללים נגיף מחשב ("וירוס"), תוכנות
              עוינות הידועות כסוס-טרויאני, תולעים
            </p>
            <p className="terms_par sub">
              27.7. סיסמאות, שמות משתמש ופרטים אחרים, המאפשרים שימוש בתוכנות
              מחשב, קבצים דיגיטאליים, אתרי אינטרנט או שירותים, הטעונים הרשמה או
              תשלום, בלא תשלום או הרשמה כאמור
            </p>
            <p className="terms_par sub">
              27.8. כל חומר המהווה לשון הרע או הפוגע בזכות לפרטיות או המהווה
              פגיעה במוניטין
            </p>
            <p className="terms_par sub">
              27.9. כל חומר בעל אופי או תוכן טורדני, מעליב, עוין, גס, גזעני,
              פוגע ברגשות הציבור, עלול להוות בסיס לתביעה אזרחית או מהווה הפרה
              אחרת של דיני מדינת ישראל
            </p>
            <p className="terms_par sub">
              27.10. כל חומר המנוגד לכללי השימוש המקובלים באינטרנט או העלול
              לגרום נזק או לפגוע במשתמשי האינטרנט בכלל ובמשתמשי האתר בפרט
            </p>
            <p className="terms_par sub">
              27.11. כל חומר שהגישה אליו חסומה באמצעות סיסמא וכיו"ב ואינה
              מתאפשרת באופן חופשי לכל משתמשי האינטרנט
            </p>
            <p className="terms_par">
              28. אתה מסכים כי החברה רשאית לסרב לפרסם, או למחוק לאלתר כל תוכן
              המפר תנאי שימוש אלה ו/או את מדיניות הפרטיות, וזאת מבלי לגרוע מכל
              זכות אחרת של החברה על פי כל דין
            </p>
            <p className="terms_par">
              29. אתה מאשר שידוע לך שהתכנים שתמסור לפרסום באתר יהיו חשופים לכל
              משתמשי האינטרנט. בהתאם, אתה מאשר שידוע לך כי עליך לנהוג בתבונה
              ובזהירות במסירת פרטים אישיים (כדוגמת כתובת או מספר טלפון) וכן
              בתגובות ובפניות שיתקבלו אצלך בעקבות השימוש באתר או פרסום איזה
              מפרטיך, וכי תשא באופן בלעדי באחריות הנובעת מהעדר הזהירות הנדרשת
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">ו. שיפוי</h4>
            <p className="terms_par">
              30. אתה מתחייב לשפות את החברה, עובדיה, מנהליה או כל גורם מטעמה,
              בגין כל נזק, הפסד או הוצאה שייגרמו למי מהם, בין באופן ישיר ובין
              בעקבות תביעת או דרישת צד שלישי כלשהו, שינבעו מכל פעולה ו/או מחדל
              מצידך, ובפרט עקב העלאת תכנים על ידך לאתר, העומדים בניגוד להוראות
              תנאי שימוש אלה או בניגוד להוראות כל דין.
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">
              ז. תוכן פרסומי – מוצרים ושירותים של צדדים שלישיים
            </h4>
            <p className="terms_par">
              31. מודעות המתפרסמות באתר מקורן בצדדים שלישיים והן מתייחסות
              לשירותים ומוצרים הניתנים על ידי צדדים שלישיים אלו, ללא מעורבות של
              החברה לעניין אספקת המוצרים או השירותים
            </p>
            <p className="terms_par">
              32. כל עסקה שתיעשה בעקבות תוכן פרסומי ו/או בעקבות שימוש באתר,
              מהווה התקשרות ישירה בין הצדדים המעוניינים בעסקה  – כלומר, אתה
              והגורם המספק את המוצר או השירות, ואינה כוללת את החברה ו/או מי
              מטעמה כצד בעסקה או כאחראית בגינה, וזאת גם אם מידע בין הצדדים יועבר
              דרך האתר עצמו, ואף אם החברה תפיק רווח כלשהו מעסקה זו, ישיר או עקיף
            </p>
            <p className="terms_par">
              33. החברה ו/או מי מטעמה לא יישאו באחריות מכל סוג שהוא לתוכן
              הפרסומי ו/או לשירותים ו/או המוצרים המסופקים על ידי מפרסמי המודעות
            </p>
            <p className="terms_par">
              34. אין לראות בתוכן הפרסומי המלצה או עידוד מטעם החברה לרכוש
              שירותים או מוצרים שמוצעים על-ידי המפרסמים
            </p>
            <p className="terms_par">
              35. כל טענה, תביעה או דרישה שיהיו למשתמש בגין הצעות, מוצרים או
              שירותים המוצעים על ידי המפרסמים, קבלתם או תוצאותיהם, יופנו על ידך
              במישרין אל הצד השלישי, ממנו קיבלת את ההצעה או רכשת את השירות, ולא
              תהיה לך כל תביעה או דרישה כלפי החברה ו/או מי מטעמה בעניינים אלו
            </p>
            <p className="terms_par">
              36. החברה שומרת לעצמה את הזכות להסיר מהאתר כל תוכן פרסומי שהוא,
              לרבות מודעות לא ראויות או מודעות אחרות בהתאם לשיקול דעתה הבלעדי
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">ח. אבטחת מידע</h4>
            <p className="terms_par">
              37. החברה תנקוט בכל הצעדים הסבירים לאבטחת המידע הנמסר על ידך
            </p>
            <p className="terms_par">
              38. עם זאת אתה מאשר שידוע לך שהחברה אינה יכולה לאבטח באופן מושלם
              את מערכות המידע והתקשורת מפני חדירות בלתי מורשות ושימוש אסור של
              צדדים שלישיים. לפיכך החברה לא תישא בכל אחריות, ישירה או עקיפה,
              במקרים של גילוי ושימוש במידע הנמסר על ידך הנובע, במישרין או
              בעקיפין, מחדירות בלתי מורשות של אחרים או כתוצאה ממעשים ו/או מחדלים
              אשר אינם בשליטתה
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">ט. שירות הכרויות</h4>
            <p className="terms_par">
              39. שירות ההיכרויות שבאתר נועד להעמיד לרשותך אמצעי המפגיש בין שני
              מבוגרים
            </p>
            <p className="terms_par">
              40. קטינים אינם רשאים להשתמש ו/או להירשם לשירות ובוגרים אינם רשאים
              ליצור קשר אסור על - פי חוק עם קטינים
            </p>
            <p className="terms_par">
              41. אתה תהיה אחראי אישית לכל קשר אשר ייוצר בינך ובין משתמש אחר
              בשירות
            </p>
            <p className="terms_par">
              42. החברה אינה יכולה לבדוק את המידע אשר יימסר על ידי המשתמשים
              בשירות והיא לא תהיה אחראית למידע כאמור, לקשר שייווצר בעקבותיו או
              להמלצות שיינתנו ליצירת הקשר, אף אם יינתנו על ידי החברה, ככל שהן
              תתבססנה על נתונים שאינם נכונים
            </p>
            <p className="terms_par">
              43. כל פגישה הנוצרת בעזרת שירות ההיכרויות באתר היא על אחריותם של
              המגיעים לפגישה ועל שיקול דעתם הבלעדי
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">י.מהי עלות השימוש באתר?</h4>
            <p className="terms_par">
              44. בגין הצפייה ו/או הגלישה באתר בלבד, החברה אינה גובה, בשלב זה,
              כל תשלום.
              <br />
              החברה גובה תשלום בגין שירותים שונים בהם השתתפות בשיעורי כושר
              גופני, הרצאות וסדנאות בזום, טיולים וקורסים או שימוש בשירות
              ההיכרויות החברה. מחירי שירותים אלו מופיעים בעמוד הרישום הרלוונטי
              לכל אחד מהם
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">יא. הוראות לעניין שירות בתשלום</h4>
            <p className="terms_par">
              45. יש לך זכות לבטל  רכישה שבוצעה באתר, לפי התנאים הבאים
            </p>
            <p className="terms_par sub">
              45.1. לגבי שירות – בתוך 14 יום מיום העסקה או מיום קבלת מסמך המפרט
              את תנאי העסקה (להלן: "<strong>מסמך ההתקשרות</strong>"), לפי
              המאוחר. כאשר מדובר בשירות שהוא עסקה מתמשכת (למשל מינויי פרימיום או
              שירותי היכרויות), בין אם החל מתן השירות ובין אם לאו. כאשר מדובר
              ברכישת שירות שאינו עסקה מתמשכת (למשל סדנאות, שיעורי ספורט,  קורסים
              וכיו"ב), ניתן לבטל בתנאי שהביטול ייעשה לפחות שני ימים, שאינם ימי
              מנוחה, קודם למועד שבו אמור השירות להינתן
            </p>
            <p className="terms_par sub">
              45.2. לגבי נכס – מיום עשיית העסקה ועד ארבעה עשר ימים מיום קבלת
              הנכס או מיום קבלת מסמך ההתקשרות, לפי המאוחר מביניהם
            </p>
            <p className="terms_par sub">
              45.3. במקרה של משתמש שהוא אדם עם מוגבלות (בהתאם לחוק שוויון זכויות
              לאנשים עם מוגבלות, התשנ"ח – 1998), אזרח ותיק (מי שמלאו לו 65 שנים)
              או עולה חדש (מי שטרם חלפו חמש שנים מיום שניתנה לו תעודת עולה או
              תעודת זכאות כעולה ממשרד העלייה והקליטה), בתוך ארבעה חודשים מיום
              העסקה, קבלת הנכס או מיום קבלת מסמך ההתקשרות, לפי המאוחר, ובתנאי
              שיצירת החשבון בתשלום כללה שיחה בינך לבין החברה, ובכלל זה באמצעות
              תקשורת אלקטרונית
            </p>
            <p className="terms_par sub">
              45.4. לגבי כל המשתמשים – לא ניתן יהיה לבטל רכישות באתר של שירותי
              הארחה, נסיעה, חופש, טיול או בילוי, אם מועד ביטול העסקה חל בתוך
              שבעה ימים שאינם ימי מנוחה, קודם למועד שבו אמור השירות להינתן
            </p>
            <p className="terms_par sub">
              45.5. לחברה תהיה הזכות לנכות מהסכום הנדרש להשבה סך 5% מערך העסקה
              או 100 ₪, לפי הנמוך מביניהם וכן תחויב בתמורה היחסית בעד השירות
              שניתן לך, אם מדובר בעסקה מתמשכת (למשל, לגבי מינויי פרימיום או
              שירות היכרויות)
            </p>
            <p className="terms_par sub">
              45.6. לאחר תקופות הביטול שמפורטות לעיל, ניתן לבטל את המינוי לחשבון
              בתשלום על ידי מסירת הודעת ביטול כמפורט בהמשך. המינוי יפקע בתוך
              שלושה ימים ממסירת הודעת הביטול, למעט במקרה שבו הודעת הביטול תימסר
              בדואר רשום, אז המינוי יפקע שישה ימים לאחר מסירתה. במקרה של ביטול
              לפי סעיף זה תחויב בתמורה היחסית בעד השירות שניתן לך ובנוסף יחולו
              דמי ביטול כמפורט במסמך ההתקשרות (אלו נקבעים בהתאם לתקופת
              ההתקשרות). כמו כן, ככל שבמהלך תקופת המינוי נרכשו פעילויות במחירים
              מוזלים, ופעילויות אלו יתרחשו רק לאחר פקיעת המינוי, יתווספו לדמי
              הביטול ההפרשים שבין המחיר הרגיל של פעילויות אלו למחיר שבו נרכשו
            </p>
            <p className="terms_par">
              46. חשבוניות יועברו אליך באמצעות דואר אלקטרוני לכתובת הדוא"ל
              העדכנית בפרטי חשבון המשתמש שלך. באחריותך לוודא כי פרטי הדוא"ל
              המופיעים במסמך ההתקשרות ואשר מופיעים בפרטי החשבון בכל מועד אחר,
              עדכניים ונכונים
            </p>
            <p className="terms_par">47. מסירת הודעת ביטול</p>
            <div className="terms_par sub">
              <div className="terms_inline_txt">
                47.1. באמצעות הקישור לביטול המופיע בעמוד הפרופיל שלך באתר, או
                במייל
              </div>
              <a
                href="mailto:shoshke@motke.co.il?subject=%D7%AA%D7%A0%D7%90%D7%99%20%D7%A9%D7%99%D7%9E%D7%95%D7%A9%20%D7%91%D7%90%D7%AA%D7%A8%20%D7%95%D7%90%D7%A4%D7%9C%D7%99%D7%A7%D7%A6%D7%99%D7%99%D7%AA%20%D7%A9%D7%95%D7%A9%D7%A7&#x27;%D7%94"
                className="terms_link"
              >
                shoshke@motke.co.il
              </a>
              <div className="terms_inline_txt">
                , או בהודעת ווטסאפ למספר 053-3769023, או בטלפון 073-2724104.
              </div>
            </div>
            <p className="terms_par sub">
              47.2. בהודעת הביטול עליך לציין את שמך, מספר הטלפון שלך ומספר
              זהותך. אם הודעת הביטול נמסרת בעל פה יש לציין פרט מזהה נוסף, אם זה
              הוסכם בינך לבין החברה בעת ההתקשרות
            </p>
            <p className="terms_par">
              48. אנא שים לב! רכישת כל מוצר, פעילות או שירותים מעבר לאלו הנרכשים
              מהחברה באתר, נעשית כאמור אל מול הצדדים השלישיים המספקים אותם, והיא
              כפופה לתנאי העסקה ו/או אתר האינטרנט של אותם צדדים שלישיים
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">יב. זכויות קניין רוחני</h4>
            <p className="terms_par">
              49. כל זכויות הקניין הרוחני באתר, ובכלל זה סימני מסחר וזכויות
              יוצרים, לעניין השירותים המוצעים בו ולעניין כל תוכן הכלול בו, לרבות
              פרסומות (ולמעט תכנים הנמסרים לפרסום על ידך אשר לא נערכו על ידי
              החברה) הן של החברה ו/או של צד שלישי
            </p>
            <p className="terms_par">
              50. אין להעתיק, להפיץ, להציג (לרבות באמצעות frames או באמצעות
              קישור עמוק (deep link) המציג באופן חלקי את עמודי האתר), לבצע,
              לשדר, לאפשר גישה, להעביר לציבור, לשנות, לעבד, ליצור יצירות נגזרות,
              למכור או להשכיר כל חלק מהתכנים המופיעים באתר, בין על ידך ובין
              באמצעות או בשיתוף צד שלישי, בכל דרך או אמצעי בין אם אלקטרוניים,
              מכאניים, אופטיים, אמצעי צילום או הקלטה, או בכל אמצעי ודרך אחרת,
              בלא קבלת הסכמה בכתב ומראש מהחברה או מבעלי הזכויות האחרים, לפי
              העניין, ובכפוף לתנאי ההסכמה (ככל שתינתן).
            </p>
            <p className="terms_par">
              51. אם ניתנה הסכמה כאמור, עליך להימנע מלהסיר, למחוק או לשבש כל
              הודעה או סימן בעניין זכויות קניין רוחני, לדוגמה - סימון זכויות
              היוצרים ©, או סימן מסחר ®, הנלווים לתכנים שיעשה בהם שימוש על ידך
            </p>
            <p className="terms_par">
              52. כאשר אתה מוסר תכנים לפרסום באתר אתה מאשר בעצם מסירתם שאתה בעל
              כל הזכויות בהם ושאתה רשאי למוסרם לפרסום. אם אינך היוצר או בעל
              הזכויות בתכנים שאתה מוסר לפרסום, אתה מאשר בעצם מסירת התכנים שקיבלת
              הרשאה כדין מבעל הזכויות למסור את התכנים לפרסום באתר ולתת בהם
              זכויות שימוש כמפורט להלן
            </p>
            <p className="terms_par">53. במסירת התכנים לפרסום אתה מקנה</p>
            <p className="terms_par sub">
              53.1. <strong>לחברה</strong> – רישיון-חינם, כלל עולמי ובלתי מוגבל
              בזמן, לעשות כל שימוש בתכנים שנמסרו, לרבות שימוש מסחרי, ובכלל זה
              ליצור יצירה נגזרת אשר הבעלות בה תהיה של החברה בלבד, להעתיק, לשכפל,
              להפיץ, לשווק, למסור לציבור, לעבד, לערוך ולתרגם, לפי שיקול דעתו
              הבלעדי של החברה בכל אמצעי פרסום, דיגטילי או אחר ובאמצעות כל רשת
              תקשורת
            </p>
            <p className="terms_par sub">
              53.2. <strong>לכל יתר המשתמשים באתר</strong> – רשות לעשות שימוש
              בתכנים אלו, בכפוף ליתר הוראות תקנון זה
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">יג. הגבלת שימוש מסחרי באתר</h4>
            <p className="terms_par">
              54. אין לעשות כל שימוש מסחרי באתר או במידע ו/או בנתונים המפורסמים
              בו, בין אם הנתונים מתפרסמים על ידי החברה, על ידי המשתמשים או על
              ידי צדדים שלישיים, בבסיס הנתונים שבאתר, או בפרטים אחרים המתפרסמים
              באתר
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">יד. שימוש בלתי ראוי</h4>
            <p className="terms_par">
              55. החברה שומרת את הזכות, לפי שיקול דעתה המלא, למנוע בכל עת שימוש
              באתר על ידי המשתמש עקב שימוש לא ראוי בשירותים, לרבות כל שימוש בלתי
              חוקי, שימוש המפריע את שימושם של אחרים באתר, פרסום והפצת חומר
              מסחרי, מעליב, בלתי מוסרי או שימוש שאינו עולה בקנה אחד עם הוראות
              תקנון זה
            </p>
            <p className="terms_par">
              56. פרט להפסקת השימוש החברה תוכל לנקוט נגדך, בהתאם לשיקול דעתה
              הבלעדי, בצעדים החוקיים המתאימים עקב כל פעולה המהווה מעשה פלילי או
              עוולה אזרחית, ובכלל זה התחזות, ניסיונות הטרדה או תרמית
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">
              טו. האם החברה תשנה את האתר או תפסיק את פעולתו
            </h4>
            <p className="terms_par">
              57. החברה תהא רשאית לשנות את מבנה האתר, מראהו, היקפו, זמינותו, את
              התכנים והשירותים המסופקים באתר ואף להפסיק את פעילותו כליל, והכל
              ללא הודעה מראש. אתה לא תוכל לבוא לחברה בכל טענה ו/או דרישה הנובעת
              משינויו של האתר ו/או הפסקת פעילותו כאמור
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">טז. דין ומקום שיפוט</h4>
            <p className="terms_par">
              58. על תקפותו, פרשנותו ו/או הפרתו של הסכם זה יחולו דיני מדינת
              ישראל
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">יז. שונות</h4>
            <p className="terms_par">
              58.1. עצם השימוש באתר מעיד על הסכמתך לתנאי השימוש המפורטים לעיל
            </p>
            <p className="terms_par">
              58.2. כל השתהות של החברה בקיום זכות המגיעה לו על פי המפורט לעיל,
              או הימנעותו של החברה מעמידה על זכותו כאמור, לא יחשבו כוויתור על
              זכות זו
            </p>
            <p className="terms_par">
              58.3. כל הודעה ביחס לאתר תפורסם באתר ותחשב כמתקבלת על ידי המשתמשים
              באתר מיד עם פרסומה כאמור, למעט אם נאמר מפורשות אחרת בתנאי שימוש
              אלה
            </p>
            <p className="terms_par">
              58.4. החברה רשאית להמחות את זכויותיה לפי מסמך תנאי שימוש זה לכל צד
              שלישי כפי שתמצא לנכון וללא כל חובה על פרסום דבר ההמחאה כאמור באתר
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TermsOfUse;
